import React from "react";
import { Transition } from "@headlessui/react";
import { cn } from "@utils";

const SkeletonLoader = ({ show }) => {
  return (
    <Transition
      show={show}
      appear
      enter="transition-opacity duration-700"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-300"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div
        className="row-start-1 col-start-1 z-20
          flex flex-col gap-8 pointer-events-none
          backdrop-blur-sm"
      >
        <div className="flex gap-4 h-10 w-full">
          <div className="h-full bg-zinc-300/40 rounded-lg w-full animate-pulse-slow" />
          <div className="h-full bg-zinc-300/40 rounded-lg w-full animate-pulse-slow-delay-1" />
        </div>
        <div className="h-5 bg-zinc-300/40 rounded-lg w-full animate-pulse-slow-delay-2" />
        {Array.from({ length: 3 }).map((_, idx) => (
          <div
            key={idx}
            className={cn(
              "h-10 bg-zinc-300/40 rounded-lg w-full",
              idx === 0 && "animate-pulse-slow-delay-1",
              idx === 1 && "animate-pulse-slow-delay-2",
              idx === 2 && "animate-pulse-slow-delay-3"
            )}
          />
        ))}
      </div>
    </Transition>
  );
};

export default SkeletonLoader;
